// Action Types
export const actionTypes = {
  GET_MAINTAINED_VALUES: "GET_MAINTAINED_VALUES",
  GET_MAINTAINED_VALUES_SUCCESS: "GET_MAINTAINED_VALUES_SUCCESS",
  GET_MAINTAINED_VALUES_FAILED: "GET_MAINTAINED_VALUES_FAILED"
};

// Action creators
export const actionCreators = {
  getMaintainedValues: params => ({
    type: actionTypes.GET_MAINTAINED_VALUES,
    params
  })
};

// Reducer
const initialState = {
  maintainedValues: null,
  isLoading: false,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_MAINTAINED_VALUES:
      return Object.assign({}, state, {
        isLoading: true,
        error: null,
        maintainedValues: null
      });

    case actionTypes.GET_MAINTAINED_VALUES_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        error: null,
        maintainedValues: action.payload
      });

    case actionTypes.GET_MAINTAINED_VALUES_FAILED:
      return Object.assign({}, state, {
        isLoading: false,
        error: action.error,
        maintainedValues: null
      });

    default:
      return state;
  }
};
